<template>
  <div>
    <div class="PcDevice_block">
      <div class="d-flex align-items-center mb-4">
        <img
          src="../assets/images/user.svg"
          class="mr-3"
          style="width: 50px; height: 50px"
          alt=""
        />
        <div>
          <h4>ចុះឈ្មោះដោយឥតគិតថ្លៃ</h4>
          <h6>
            ងាយស្រួលក្នុងការចូល និងផ្លាស់ប្តូរព័ត៌មានឧស្សាហកម្មកាន់តែល្អប្រសើរ
          </h6>
        </div>
      </div>
      <p>
        ទទួលបានព័ត៌មានចុងក្រោយនៃការតាំងពិព័រណ៍របស់យើង
        ទទួលបានសារពីព្រឹត្តិការណ៍ពិព័រណ៍ ការបញ្ចុះតម្លៃសមាជិក
        និងទទួលបានព័ត៌មានពិព័រណ៍របស់យើងដោយឥតគិតថ្លៃ
      </p>

      <a
        href="https://www.chanchao.com.tw/accounts/km/signup"
        class="btn btn-block btn-secondary mt-3"
        >សំណួរ</a
      >

      <hr />
    </div>

    <h4 class="my-4">សំណួរ</h4>

    <ul class="ml-0 pl-4">
      <li>
        <a
          href="https://www.chanchao.com.tw/downloads/%E6%9C%83%E5%93%A1%E8%A8%BB%E5%86%8A%E7%AF%87_En.pdf"
          target="_blank"
          >របៀបក្លាយជាសមាជិក</a
        >
      </li>
      <li>
        <a
          href="https://www.chanchao.com.tw/downloads/%E9%82%80%E8%AB%8B%E4%BB%A3%E7%A2%BC%E7%B4%A2%E7%A5%A8_En.pdf"
          target="_blank"
          >របៀបទទួលបានសំបុត្រ?</a
        >
      </li>
      <li>
        <a
          href="https://www.chanchao.com.tw/downloads/%E5%BF%AB%E9%80%9F%E5%85%A5%E5%A0%B4%E7%AF%87(%E6%89%8B%E6%A9%9F%E7%89%88)_En.pdf"
          target="_blank"
          >របៀបចូលប្រើរហ័ស?</a
        >
      </li>
    </ul>

    <div class="d-flex mt-3">
      <a href="//www.chanchao.com.tw/en/qa.asp" target="_blank"
        >សំណួរ<i class="fas fa-external-link-alt ml-2"></i
      ></a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  methods: {},

  created() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
